import { render, staticRenderFns } from "./PrivacyIndex.vue?vue&type=template&id=ec68243a&scoped=true"
import script from "./PrivacyIndex.vue?vue&type=script&lang=js"
export * from "./PrivacyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec68243a",
  null
  
)

export default component.exports